var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scroll-div summary_page" },
    [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" },
        [
          _c("div", { staticClass: "row summary_reg_title" }, [
            _vm.initialCallsDone
              ? _c("div", { staticClass: "chart-title" }, [
                  _c("span", [_vm._v("Number of registrations over time")]),
                ])
              : _vm._e(),
          ]),
          _vm.initialCallsDone
            ? _c(
                "div",
                { staticClass: "range-div col-md-12 col-lg-12 col-sm-12 p-0" },
                [
                  _vm.permissions.indexOf("EDIT_SUMMARY_EXPORT_DATE_RANGE") > -1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-md-8 col-lg-8 col-sm-10 col-xs-12 p-0",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "mr-lt-15 date_range_element date_range_cls",
                            },
                            [_vm._v("Date Range")]
                          ),
                          _c("date-picker", {
                            staticClass:
                              "mr-lt-15 date_range_summary_tab date_range_element",
                            attrs: {
                              id: "datepickerFrom",
                              "default-value": _vm.forecastStartDate
                                ? _vm.forecastStartDate
                                : new Date(),
                              type: "date",
                              "disabled-date": _vm.notBeforeEndDate,
                              editable: false,
                              format: "DD/MM/YYYY",
                              placeholder: "DD/MM/YYYY",
                            },
                            on: { change: _vm.onForecastPeriodChange },
                            model: {
                              value: _vm.forecastStartDate,
                              callback: function ($$v) {
                                _vm.forecastStartDate = $$v
                              },
                              expression: "forecastStartDate",
                            },
                          }),
                          _c("span", { staticClass: "start-to-end" }, [
                            _vm._v("to"),
                          ]),
                          _c("date-picker", {
                            staticClass:
                              "date_range_summary_tab date_range_element",
                            attrs: {
                              id: "datepickerTo",
                              "default-value": _vm.forecastEndDate
                                ? _vm.forecastEndDate
                                : new Date(),
                              type: "date",
                              "disabled-date": _vm.notBeforeStartDate,
                              editable: false,
                              format: "DD/MM/YYYY",
                              placeholder: "DD/MM/YYYY",
                            },
                            on: { change: _vm.onForecastPeriodChange },
                            model: {
                              value: _vm.forecastEndDate,
                              callback: function ($$v) {
                                _vm.forecastEndDate = $$v
                              },
                              expression: "forecastEndDate",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.permissions.indexOf("EXPORT_SUMMARY") > -1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-md-4 col-lg-4 col-sm-2 col-xs-12 xs-pt-10 pl-0",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn emergo-white-button",
                              attrs: {
                                disabled:
                                  !_vm.registrationOverTimeData ||
                                  !_vm.registrationOverTimeData.length,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.exportPopup("forecastsvg")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "margin-btn-plus-icon",
                                attrs: {
                                  src: "/static/images/icons/icon_share.svg",
                                  alt: "share-icon",
                                },
                              }),
                              _vm._v(" Export "),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.initialCallsDone
            ? _c(
                "div",
                {
                  staticClass:
                    "col-lg-12 col-xs-12 col-sm-12 col-md-12 horizontal_legend_summary",
                  attrs: { id: "legend2" },
                },
                [
                  _c("span", {
                    staticClass: "key_dot key_dot_registration legend_active",
                  }),
                  _c("span", { staticClass: "legend_name" }, [
                    _vm._v("Registrations"),
                  ]),
                  _c("span", {
                    staticClass: "key_dot key_dot_actual legend_active",
                  }),
                  _c("span", { staticClass: "legend_name" }, [
                    _vm._v("Actual"),
                  ]),
                  _c("span", {
                    staticClass: "key_dot key_dot_forecast legend_active",
                  }),
                  _c("span", {
                    staticClass: "key_dot key_dot_forecast legend_active",
                  }),
                  _c("span", { staticClass: "legend_name" }, [
                    _vm._v("Forecast"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._m(0),
        ]
      ),
      _vm.initialCallsDone
        ? _c(
            "div",
            { staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0" },
            [_c("hr")]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0" },
        [
          _c("div", { staticClass: "row summary_reg_title" }, [
            _vm.initialCallsDone
              ? _c(
                  "div",
                  { staticClass: "chart-title col-md-12 upcoming-expirations" },
                  [_c("span", [_vm._v("Upcoming expirations")])]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "row" }, [
            _vm.initialCallsDone
              ? _c(
                  "div",
                  {
                    staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-8 col-sm-7 col-xs-12 p-0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-lt-15 upcom_expiration_input col-lg-2 col-md-3 col-sm-3 col-xs-12",
                          },
                          [_vm._v("Over the next")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-sm-4 col-xs-5 p-0 mr-lt-15 summary-dropdown",
                          },
                          [
                            _c(
                              "multiselect",
                              {
                                staticClass: "multiselect-single-dropdown",
                                attrs: {
                                  showLabels: false,
                                  "close-on-select": true,
                                  "allow-empty": false,
                                  searchable: true,
                                  options: _vm.expirationPeriod,
                                  label: "period",
                                  "track-by": "months",
                                  placeholder: "Select",
                                },
                                on: { input: _vm.onExpirationPeriodChange },
                                model: {
                                  value: _vm.selectedExpirationPeriod,
                                  callback: function ($$v) {
                                    _vm.selectedExpirationPeriod = $$v
                                  },
                                  expression: "selectedExpirationPeriod",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("No matching data")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.permissions.indexOf("EXPORT_UPCOMING_EXPIRATIONS") > -1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 col-sm-4 col-xs-12 xs-pt-10 pl-0",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn emergo-white-button",
                                attrs: {
                                  disabled: _vm.disableUpcomingExpButton,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exportPopup("expirationSVG")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "margin-btn-plus-icon",
                                  attrs: {
                                    src: "/static/images/icons/icon_share.svg",
                                    alt: "share-icon",
                                  },
                                }),
                                _vm._v(" Export "),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.initialCallsDone
            ? _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 horizontal_legend_summary",
                  attrs: { id: "legend2" },
                },
                [
                  _c("span", {
                    staticClass: "key_dot key_dot_registration legend_active",
                  }),
                  _c("span", { staticClass: "legend_name" }, [
                    _vm._v("Registrations"),
                  ]),
                ]
              )
            : _vm._e(),
          _c("div", {
            staticClass: "expired-Bar-Chart",
            attrs: { id: "expirationBarChartDiv" },
          }),
        ]
      ),
      _c("loader", { attrs: { loadingStatus: _vm.chartLoaderStatus } }),
      _c("registration-details-popup", {
        attrs: {
          permissions: _vm.permissions,
          dataRow: _vm.activeRegistration,
          archivedFlag: _vm.archivedFlag,
          reportFlag: _vm.reportFlag,
        },
        on: { hidePopup: _vm.hidePopup },
      }),
      _c("permission-access-modal"),
      _c("export-popup", {
        attrs: { documentId: _vm.documentId },
        on: { resetExportPopup: _vm.resetExportPopup },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0" },
      [
        _c("div", {
          staticClass: "registration-Over-Time-Chart",
          attrs: { id: "registrationOverTimeChartDiv" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }